<div class="card-inner-main-div">
  <div class="pt-1 pb-3 d-flex justify-content-between">
    <span class="fw-14"><img src="assets/images/message-icon.svg" class="mr-1"> {{'Comments & Notes' | translate}}</span>
    <a><img class="sm-image-icon grey-icon-image" alt="" src="assets/images/three-dash-icon.svg"></a>
  </div>

  @if (loadCommentsAndNotes || loadingAssessments) {
    <div class="curved-section-shadow">
      <app-widget-loader></app-widget-loader>
    </div>
  } @else {
    @if (comments?.length || tasksAssignmentNotes?.length) {
      <ul class="comments-notes-div custom-scrollbar curved-section-shadow">
        @for (comment of comments; track trackById($index, comment)) {
          <li class="comment-list" id="c-{{comment.id}}" (click)="showCommentRange(comment)">
            <div class="comment-num"><i class="purple-bg"> {{ comment.id }}</i></div>
            <div class="comment-content">
              <p> {{ comment.text}}</p>
              <p class="date-time">{{comment.dateCreated | dateFormat:dateFormatHMSA}}</p>
            </div>
            <span class="comment-action">
              <i (click)="editComment($event, comment)" class="edit-icon fa fa-pen"></i>
              <i (click)="deleteComment($event, comment.id)" class="delete-icon fa fa-trash"></i>
            </span>
          </li>
        }
        @for (notes of tasksAssignmentNotes; track trackById($index, notes)) {
          <li class="comment-list" id="n-{{notes.id}}" (click)="showNoteRange(notes)">
            <div class="comment-num"><i class="purple-bg"> IH</i></div>
            <div class="comment-content">
              <p> {{ notes?.text}}</p>
              @if (notes?.type == 2) {
                <div>
                  <video width="320" height="240" controls>
                    <source [src]="$safeNavigationMigration(notes?.url)" type="video/mp4">
                  </video>
                </div>
              }
              @if (notes?.type == 1) {
                <div>
                  <audio controls>
                    <source [src]="$safeNavigationMigration(notes?.url)" type="audio/mpeg">
                    {{'Your browser does not support the audio tag' | translate}}
                  </audio>
                </div>
              }
              <p class="date-time">{{$safeNavigationMigration(notes?.dateCreated) | dateFormat:dateFormatHMSA}}</p>
            </div>
          </li>
        }
      </ul>
    } @else {
      <div class="curved-section-shadow" [innerHTML]="errorHtml"></div>
    }
  }

</div>
<app-edit-comment
  [show]="showEditComment"
  [comment]="selectedComment"
  [triggerPopulateForm]="triggerPopulateForm"
  (hideFormEmit)="hideEditForm()"
  (updateGraphAndNotes)="updateGraphAndNotesFn()"
  (resetTriggerPopulateFormEmit)="resetTriggerPopulateForm()"
></app-edit-comment>
